var map = {
	"./dog.png": 445,
	"./dog1.png": 446,
	"./dog2.png": 447,
	"./dog3.png": 448,
	"./dog4.png": 449,
	"./dog5.png": 450,
	"./dog6.png": 451,
	"./dog7.png": 452,
	"./dog8.png": 453
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 444;